module.exports = __webpack_public_path__ + "img/muvelet9.cc06211a.png";